'use client';

import type { NewsletterFormFragment } from '@mnd-apps/public/wp-generated/types';
import {
  SPACING_2,
  SPACING_4,
  SPACING_6,
  SPACING_10,
  WEB_GREY_LT,
} from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import NewsletterSignupForm from './NewsletterSignupForm';

const NEWSLETTER_MODULE_WIDTH = '50rem';

const Title = styled.h2`
  // @todo use token: web/subheading/mobile
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: -0.03375rem;

  @media (min-width: calc(${NEWSLETTER_MODULE_WIDTH} + ${SPACING_4})) {
    // @todo use token: web/subheading/desktop
    font-size: 1.375rem;
    line-height: 1.65rem;
    letter-spacing: -0.04125rem;
  }
`;

const Container = styled.div`
  display: flex;
  gap: ${SPACING_2};
  flex-direction: column;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: ${NEWSLETTER_MODULE_WIDTH};
  padding: ${SPACING_6} ${SPACING_2};
  margin: 0 auto;

  @media (min-width: calc(${NEWSLETTER_MODULE_WIDTH} + ${SPACING_4})) {
    padding: ${SPACING_10} 0;
  }
`;

const Background = styled.div`
  background: ${WEB_GREY_LT};
`;

const NewsLetterSignupModule = ({ moduleData }: { moduleData: NewsletterFormFragment }) => {
  return (
    <Background>
      <Container>
        <Title>{moduleData.title}</Title>
        <NewsletterSignupForm hubspotFormId={moduleData.hubspotFormId ?? ''} />
      </Container>
    </Background>
  );
};

export default NewsLetterSignupModule;
